/*
  SVENSK udgave til weightnordic.se (Jacob 30.10.2026): vibrationstränare 1 839 SEK, de nye pakker og Weight Nordic
  Löpband med Black Month-pris, gratis blodtrycksmätare på alle varer. Kun blodtrycksmätaren som gave i Sverige.

  Black Month på alle produktsider (Weight Nordic, Black Month 2026).
  Hentes fra Shopify Filer af blokken i bm-produktside.liquid.
  - Sort bånd øverst med gaven og hvor længe Black Month varer
  - "BLACK MONTH"-mærke ved produktnavnet og på produktbilledet
  - Købsboks med pris og gratis blodtryksmåler (som på vibrationstræneren). Temaets prislinje
    skjules, og dermed også mærket "Gratis elastikker + træningsprogram", som kun må stå på
    vibrationstræneren (Jacob 30.10.2026). Vibrationstræneren har sin egen boks (data-bm-kb).
  Regler: "Black Month pris" kun hvor prisen er sat ned, ingen førpris, ingen kroneværdi på gaven,
  blodtryksmåleren omtales sagligt (regler.md). Slukker af sig selv efter 30.11.2026.
*/
(function () {
  var SLUT = new Date('2026-12-01T00:00:00+01:00').getTime();
  if (Date.now() >= SLUT) return;

  var data = document.querySelector('[data-bm-ps]');
  if (!data) return;
  var handle = data.getAttribute('data-handle');
  var vib = false; // i Sverige har vibrationstränaren ingen egen boks, og gaven er kun blodtrycksmätaren

  // Kun produkter, hvor prisen faktisk er sat ned, får "Black Month pris"
  var CFG = {
    'vibrationstranare': { chip: 'Black Month-pris' },
    'weight-nordic-lopband': { chip: 'Black Month-pris' },
    'kretsloppspaketet': { chip: 'Black Month-pris' },
    'varma-fotter-paketet': { chip: 'Black Month-pris' },
    'vibrationstranare-med-stodstang': { chip: 'Black Month-paketet', note: 'Fjärrkontroll ingår' }
  };
  var cfg = CFG[handle] || {};

  var css = '' +
    '.bm-ps-band{background:#0c0c0c;color:#f2d9a8;display:flex;flex-wrap:wrap;justify-content:center;align-items:center;gap:6px 14px;padding:10px 16px;font-size:13px;line-height:1.3;letter-spacing:.06em;text-transform:uppercase;text-align:center}' +
    '.bm-ps-band strong{color:#c9a253;font-weight:800;letter-spacing:.14em}' +
    '.bm-ps-band__dot{width:5px;height:5px;border-radius:50%;background:#c9a253;flex:none}' +
    '.bm-ps-band__gave{font-weight:700}' +
    '.bm-ps-band__tid{color:#fff;font-weight:600}' +
    '.bm-ps-pill{display:inline-block;flex:none;white-space:nowrap;margin-right:10px;padding:3px 9px;border-radius:999px;background:#0c0c0c;color:#c9a253;font-size:11px;font-weight:800;letter-spacing:.12em;vertical-align:middle}' +
    '.bm-ps-img{position:absolute;left:16px;bottom:16px;z-index:2;pointer-events:none;display:flex;flex-direction:column;gap:2px;background:#0c0c0c;border:1px solid #c9a253;border-radius:10px;padding:8px 12px;line-height:1.15}' +
    '.bm-ps-img strong{color:#c9a253;font-size:15px;font-weight:800;letter-spacing:.12em}' +
    '.bm-ps-img span{color:#fff;font-size:12px;font-weight:600}' +
    '.bm-kb{border:2px solid #0c0c0c;border-radius:14px;overflow:hidden;background:#fff;width:100%}' +
    '.bm-kb__head{display:flex;justify-content:space-between;align-items:center;gap:8px;background:#0c0c0c;color:#f2d9a8;padding:10px 16px;font-size:13px;font-weight:700;letter-spacing:.06em;text-transform:uppercase}' +
    '.bm-kb__date{font-weight:500;letter-spacing:.02em;text-transform:none;color:#c9a253}' +
    '.bm-kb__price{display:flex;align-items:center;flex-wrap:wrap;gap:12px;padding:16px 16px 6px}' +
    '.bm-kb__amount{font-size:30px;font-weight:700;line-height:1;color:#0c0c0c}' +
    '.bm-kb__chip{background:#c9a253;color:#0c0c0c;font-size:13px;font-weight:700;padding:6px 12px;border-radius:999px}' +
    '.bm-kb__note{padding:0 16px;font-size:14px;font-weight:600;color:#0c0c0c}' +
    '.bm-kb__gifts{margin:10px 12px 12px;background:#faf6ee;border:1px solid #eadfca;border-radius:10px}' +
    '.bm-kb__gifts-label{margin:0;padding:10px 12px 2px;font-size:13px;font-weight:600;color:#0c0c0c}' +
    '.bm-kb__row{display:flex;align-items:center;gap:12px;padding:10px 12px}' +
    '.bm-kb__img{width:56px;height:56px;border-radius:8px;object-fit:cover;background:#fff;flex:none}' +
    '.bm-kb__txt{flex:1;display:flex;flex-direction:column;gap:2px;line-height:1.3}' +
    '.bm-kb__txt strong{font-size:15px;color:#0c0c0c}' +
    '.bm-kb__txt small{font-size:13px;color:#555}' +
    '.bm-kb__free{font-size:14px;font-weight:700;color:#1d7a46}' +
    '@media (max-width:749px){.bm-ps-band{font-size:11px;letter-spacing:.04em;gap:4px 10px;padding:8px 12px}.bm-ps-band__mere{display:none}.bm-ps-img{left:10px;bottom:10px;padding:6px 10px}.bm-ps-img strong{font-size:13px}.bm-ps-img span{font-size:11px}}';
  // Temaets prislinje skjules kun, når vores boks vises (vibrationstræneren skjuler den selv)
  // Kun varer med Black Month-pris får prisen i boksen. De andre beholder temaets prislinje med førpris (Jacob 30.10.2026:
  // svenske førpriser bliver stående), og boksen viser kun gaven under den, så førprisen ikke ligner et Black Month-tilbud.
  if (cfg.chip) css += '.pdp-hero__price{display:none!important}';
  var style = document.createElement('style');
  style.textContent = css;
  document.head.appendChild(style);

  function tekstTid() {
    var ms = SLUT - Date.now();
    if (ms <= 0) return 'Slutar i dag';
    var dage = Math.floor(ms / 86400000);
    if (dage >= 2) return 'Slutar om ' + dage + ' dagar';
    var t = Math.floor(ms / 3600000), m = Math.floor(ms % 3600000 / 60000);
    return 'Slutar om ' + t + ' tim ' + m + ' min';
  }

  // Bånd øverst på siden
  var band = document.createElement('div');
  band.className = 'bm-ps-band';
  band.innerHTML = '<strong>Black Month</strong><span class="bm-ps-band__dot"></span>' +
    '<span class="bm-ps-band__gave">' + 'Gratis blodtrycksmätare<span class="bm-ps-band__mere"> med ditt köp</span>' + '</span>' +
    '<span class="bm-ps-band__dot"></span><span class="bm-ps-band__tid" data-bm-ps-tid></span>';
  var tid = band.querySelector('[data-bm-ps-tid]');
  tid.textContent = tekstTid();
  setInterval(function () { tid.textContent = tekstTid(); }, 60000);

  // Mærke nederst til venstre på produktbilledet
  var imgMark = document.createElement('div');
  imgMark.className = 'bm-ps-img';
  imgMark.innerHTML = '<strong>BLACK MONTH</strong><span>' + 'Gratis blodtrycksmätare' + '</span>';

  // Købsboks til alle andre produkter end vibrationstræneren
  var box = null;
  if (!vib) {
    box = document.createElement('div');
    box.className = 'bm-kb';
    box.innerHTML = '<div class="bm-kb__head"><span>Endast under Black Month</span><span class="bm-kb__date">t.o.m. 30/11</span></div>' +
      (cfg.chip ? '<div class="bm-kb__price"><span class="bm-kb__amount"></span><span class="bm-kb__chip">' + cfg.chip + '</span></div>' : '') +
      (cfg.note ? '<div class="bm-kb__note">✓\u00a0' + cfg.note + '</div>' : '') +
      '<div class="bm-kb__gifts"><p class="bm-kb__gifts-label">Gratis gåva med ditt köp</p>' +
      '<div class="bm-kb__row"><img class="bm-kb__img" alt="Blodtrycksmätare" width="56" height="56" loading="lazy">' +
      '<div class="bm-kb__txt"><strong>Blodtrycksmätare</strong><small>För överarmen. Ingår i leveransen</small></div>' +
      '<span class="bm-kb__free">Gratis</span></div></div>';
    if (cfg.chip) box.querySelector('.bm-kb__amount').textContent = data.getAttribute('data-price');
    box.querySelector('.bm-kb__img').src = data.getAttribute('data-gave');
  }

  function place() {
    var main = document.getElementById('MainContent');
    if (main && main.firstElementChild !== band) main.insertAdjacentElement('afterbegin', band);
    var eyebrow = document.querySelector('#MainContent .pdp-hero__eyebrow');
    if (eyebrow && !eyebrow.querySelector('.bm-ps-pill')) {
      var pill = document.createElement('span');
      pill.className = 'bm-ps-pill';
      pill.textContent = 'BLACK MONTH';
      eyebrow.insertAdjacentElement('afterbegin', pill);
    }
    var slides = document.querySelector('#MainContent .pdp-hero__media slideshow-container');
    if (slides && imgMark.parentElement !== slides) slides.appendChild(imgMark);
    if (box) {
      var price = document.querySelector('#MainContent .pdp-hero__price');
      if (cfg.chip) {
        if (price && price.previousElementSibling !== box) price.insertAdjacentElement('beforebegin', box);
      } else {
        // Under prislinjen og ViaBill/afbetaling, så førprisen står for sig selv
        var after = document.querySelector('#MainContent .pdp-hero__installments') || price;
        if (after && after.nextElementSibling !== box) after.insertAdjacentElement('afterend', box);
      }
    }
  }
  place();
  document.addEventListener('DOMContentLoaded', place);
  var timer;
  new MutationObserver(function () { clearTimeout(timer); timer = setTimeout(place, 100); })
    .observe(document.documentElement, { childList: true, subtree: true });
})();
